import { useState, useCallback } from 'react';
import type { LatLng } from '@/types';

interface GeolocationState {
  loading: boolean;
  error: string | null;
}

export function useGeolocation() {
  const [state, setState] = useState<GeolocationState>({
    loading: false,
    error: null,
  });

  const getCurrentLocation = useCallback((): Promise<LatLng> => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        const error = 'Geolocation is not supported by this browser';
        setState({ loading: false, error });
        reject(new Error(error));
        return;
      }

      setState({ loading: true, error: null });

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latLng: LatLng = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          setState({ loading: false, error: null });
          resolve(latLng);
        },
        (error) => {
          const errorMessage = `Error getting location: ${error.message}`;
          setState({ loading: false, error: errorMessage });
          reject(new Error(errorMessage));
        }
      );
    });
  }, []);

  return {
    ...state,
    getCurrentLocation,
  };
}
